import { Button } from '@mui/material'

import { useMe, useSend2FAEmailVerification } from 'src/hooks'

import { useStyles } from '../../styles'
import { ETranslationNs } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'

export const SendStep = () => {
  const { data: me } = useMe()
  const classes = useStyles()

  const { mutate: sendCode, isLoading: isSending } = useSend2FAEmailVerification()

  const handleCodeSend = () => {
    sendCode()
  }

  return (
    <div className={classes.section}>
      <p className={classes.stepText}>
        <HelperWrapper t="2fa-step-text" ns={ETranslationNs.UserProfile} />1
      </p>
      <h3 className={classes.sectionTitle}>
        <>
          <HelperWrapper t="2fa-email-setup-title" ns={ETranslationNs.UserProfile} />
          {me && <span className={classes.userEmail}>{me.email}</span>}
        </>
      </h3>
      <p className={classes.sectionText}>
        <HelperWrapper t="2fa-email-setup-text" ns={ETranslationNs.UserProfile} />
      </p>
      <Button
        size="medium"
        className={classes.codeButton}
        disabled={isSending}
        onClick={handleCodeSend}
      >
        <HelperWrapper t="2fa-modal-email-send-button" ns={ETranslationNs.UserProfile} />
      </Button>
    </div>
  )
}
